/** Converts a given value from an input unit to an output unit. */
export function convertUnits<T>(
  /** Input value */
  value: number,
  /** Unit for the input value to start the conversion from. */
  inputUnit: T | string,
  /** Unit for the output value. */
  outputUnit: T | string,
  /** Conversion table to be used as mapping */
  conversionTable: Array<{ multiplier: number; postfix: T | string }>,
): number {
  // Early exit if input and output unit are the same
  if (inputUnit === outputUnit) {
    return value;
  }

  // Find the input units index in the conversionTable to get the conversion
  // factor to calculate the base bit value.
  const inputIndex = conversionTable.findIndex(
    (level) => level.postfix === inputUnit,
  );
  if (inputIndex === -1) {
    throw new Error(
      `Input unit '${inputUnit}' was not found in the conversion table.`,
    );
  }
  // Find the output units index in the conversionTable to get the conversion
  // factor to calculate the value in output units.
  const outputIndex = conversionTable.findIndex(
    (level) => level.postfix === outputUnit,
  );
  if (outputIndex === -1) {
    throw new Error(
      `Output unit '${outputUnit}' was not found in the conversion table.`,
    );
  }

  // To convert the value, calculate the value in bits first and use the bitbased
  // multiplier to convert to the output unit.
  const outputValue =
    (value * conversionTable[inputIndex].multiplier) /
    conversionTable[outputIndex].multiplier;

  return outputValue;
}
